import React from 'react'
import styled, { keyframes } from 'styled-components'

const variants = {
  medium: {
    dot: '12px',
    ring: '24px'
  },
  small: {
    dot: '8px',
    ring: '16px'
  }
}

type Variant = keyof typeof variants

const pulsate = keyframes`
  0% {transform: scale(0.1, 0.1); opacity: 0.0;}
  50% {opacity: 1.0;}
  100% {transform: scale(1.2, 1.2); opacity: 0.0;}
`

const DotContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 8px;
  top: -1px;
`

const Dot = styled.div<{ variant: Variant }>`
  width: ${(props) => variants[props.variant].dot};
  height: ${(props) => variants[props.variant].dot};
  background-color: var(--red-60);
  border-radius: 50%;
  position: absolute;
`

const DotRing = styled.div<{ variant: Variant }>`
  border: 2px solid var(--red-60);
  border-radius: 50%;
  width: ${(props) => variants[props.variant].ring};
  height: ${(props) => variants[props.variant].ring};
  position: absolute;
  animation: ${pulsate} 1.4s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
`

interface Props {
  className?: string
  variant?: Variant
}

export const LiveDot = ({ className, variant = 'small' }: Props) => {
  return (
    <DotContainer className={className}>
      <Dot variant={variant} />
      <DotRing variant={variant} />
    </DotContainer>
  )
}
